import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import CommandPalette from "./CommandPalette";
import { AskAtomDock } from "./AskAtomDock";
import { ExaminerBanner } from "./ExaminerBanner";
import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";

export default function AppShell() {
  const [cmdOpen, setCmdOpen] = useState(false);
  const { user, loaded } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (loaded && !user) nav("/login");
  }, [user, loaded, nav]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setCmdOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  if (!loaded || !user) return null;

  return (
    <div className="flex min-h-screen bg-bg">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onOpenSearch={() => setCmdOpen(true)} />
        <main className="flex-1 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
      <CommandPalette open={cmdOpen} onClose={() => setCmdOpen(false)} />
      <AskAtomDock />
      <ExaminerBanner />
    </div>
  );
}
